const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速秒开',
    desc: '自研智能加速引擎，点击即播不缓冲，告别加载等待，观影零延迟体验。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '全站蓝光高清片源覆盖，支持多码率自适应，无论大屏小屏都清晰细腻。',
  },
  {
    icon: 'ri-slideshow-3-line',
    title: '海量片库',
    desc: '收录超十万部电影电视剧，从经典老片到热播新剧，免费影视大全一站畅享。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: 'PC、平板、手机全终端适配，播放记录云端同步，随时随地继续观看。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '纯净观影',
    desc: '绿色安全无弹窗广告，专注观影体验，1080P高清不卡顿流畅播放。',
  },
];

export default function AppFeaturesSection() {
  return (
    <>
      <section id="app" className="relative w-full py-16 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-gradient-to-br from-background-100 to-background-200/50 rounded-lg p-6 md:p-10 border border-background-200/40">
            <div className="flex-shrink-0 w-32 h-32 md:w-40 md:h-40 rounded-lg overflow-hidden bg-background-200/50 flex items-center justify-center">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20cinematic%20movie%20streaming%20app%20interface%20with%20film%20posters%20and%20play%20button%2C%20dark%20theme%20UI%20design%20with%20warm%20amber%20accents%2C%20sleek%20minimal%20layout%2C%20product%20photography%20on%20dark%20background%2C%20premium%20quality&width=400&height=400&seq=app-qr-6080&orientation=squarish"
                alt="6080新视觉影院 APP客户端下载"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-3">
                APP客户端
              </h2>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-5 max-w-lg">
                下载6080新视觉影院APP，享受更流畅的高清电影电视剧免费在线观看体验。移动端专属优化，不缓冲极速秒开，全集不卡顿，随时随地畅享观影。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <span className="inline-flex items-center gap-1.5 px-4 py-2 bg-background-200/60 rounded-md text-xs text-foreground-500 cursor-pointer hover:bg-background-200 transition-colors whitespace-nowrap">
                  <i className="ri-android-line text-base text-secondary-400"></i>
                  Android 下载
                </span>
                <span className="inline-flex items-center gap-1.5 px-4 py-2 bg-background-200/60 rounded-md text-xs text-foreground-500 cursor-pointer hover:bg-background-200 transition-colors whitespace-nowrap">
                  <i className="ri-apple-line text-base text-secondary-400"></i>
                  iOS 下载
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="features" className="relative w-full py-16 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              为什么选择我们
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              五大核心优势，打造极致的高清电影电视剧免费在线观看体验
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
            {features.map((item, idx) => (
              <div
                key={idx}
                className="group bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/40 hover:border-primary-500/20 transition-all duration-300 cursor-default"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500/10 mb-4 group-hover:bg-primary-500/20 transition-colors">
                  <i className={`${item.icon} text-lg text-primary-400`}></i>
                </div>
                <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-800 mb-2 whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}